module.exports = __webpack_public_path__ + "img/newspapers_button_previous_up.a9134003.png";